import { render, staticRenderFns } from "./ThanksBlocksTable.vue?vue&type=template&id=a4d1d0dc&scoped=true"
import script from "./ThanksBlocksTable.vue?vue&type=script&lang=js"
export * from "./ThanksBlocksTable.vue?vue&type=script&lang=js"
import style0 from "./ThanksBlocksTable.vue?vue&type=style&index=0&id=a4d1d0dc&prod&lang=css"
import style1 from "./ThanksBlocksTable.vue?vue&type=style&index=1&id=a4d1d0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d1d0dc",
  null
  
)

export default component.exports